import { Component } from "../../core/Component";
import baguetteBox from "baguettebox.js";
import baguetteConfig from "~/shared/configs/baguetteBox.config";
import { VideoItem } from "../VideoComponent.js/Video.component";
import videoJs from "video.js";
export class RadioComponent extends Component {
  /**
   * @type number */
  #currentIndex;
  constructor($root, options) {
    super($root, options);
    this.classPosition = {
      0: "left",
      1: "right",
      2: "bottom",
      3: "top"
    };
    this.allStyle = options.allStyle || null;
    this.messages = options.messages;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "radio";
    this.require = options.required === 1;
    this.placeholder = options.placeholder || "";
    this.typeId = options.typeId;
    this.fieldId = options.id;
    this.classes = options.classes || "";
    this.useDesign = options.useDesign;
    // установка пользовательских классов оформления
    // this.setUserClasses()
    this.wrapClasses = this.makeWrapUserClasses();
    this.formWidth = options.formWidth || options.data.width;
    this.fontStyle = {
      family: options.data.style.formStyleText.font?.cssName ?? "inherit",
      size: options.data.style.formStyleText.fontSize
    };
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formIndex}`; //${options.formId}_${options.formIndex}_${options.name}
    this.boxId = `${options.name}_${options.formIndex}_box`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text`;
    this.labelId = `${options.name}_${options.formIndex}_label`;
    this.inputIds = [];
    this.defaultValueId = null;
    this.otherInputId = `${options.name}_${options.formIndex}_other-item-input`;
    this.otherInputBoxId = `${options.name}_${options.formIndex}_other-item-input-box`;
    this.$otherInput = null;
    this.$otherInputBox = null;
    this.shuffle_answers = !!options.shuffle_answers;
    this.thumbnailSize = options.thumbnailSize; // Способ отображения миниатюр: 0 - вместить, 1 - заполнить
    this.fieldRounding = [0, "5px", "25px"][options.useDesign ? options.allStyle.formStyleCommon.fieldRounding : 0];
    /**
     * @type {Array<{ index: number, image: string, description: string, key: string, mainVideo: string }>}
     **/
    this.imageData = [];
    this.videoWidgets = [];
    this.saveInStorage = this.options.data.saveInStorage;
    this.widgetData = [];
    this.captionLink = options.captionLink ?? "https://ru.qform.io";
  }

  /**
   *
   * @param {Array<FormFieldOption>} option - массив с вариантами выбора
   * @param {*} isMultipleCol - флаг добавления класса для нескольких колонок (используется при добавлении вариантов выбора)
   * @returns $el
   */
  toHTML() {
    let option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let isMultipleCol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let radio = `<div 
      class="qform-field radio ${this.hint ? "qform-hint" : ""} ${this.wrapClasses?.join(" ") || ""} ${isMultipleCol ? "multiple-col" : ""}" id="${this.boxId}">
        <div class="qform-field_wrap">
        ${this.toHtmlOutLabelBox()}
          <div class="qform-field__block">
            <div class="qform-field__block_box">
              <div class="qform-field__block_box__field">
                <div class="qform-field__block_box__field-box">`;
    //добавление вариантов выбора к полю
    if (option.length) {
      this.inputIds = [];
      option.forEach((x, index) => {
        const uniqId = Date.now().toString(36) + Math.random().toString(36);
        /**
         * @param
         * @type VideoItem
         * */
        let videoItem = null;
        if (x.videowidget.mainVideo !== undefined) {
          videoItem = new VideoItem({
            index: `${x.key}_${this.name}_thumb`,
            id: this.id,
            mainVideo: x.videowidget.mainVideo,
            showLogo: x.videowidget.showLogo,
            preview: x.videowidget.preview,
            userPreviewImg: x.videowidget.userPreviewImg,
            widgetId: x.videowidget.widgetId
          }, {
            thumbnailSize: this.thumbnailSize
          });
          this.videoWidgets.push(videoItem);
        }
        this.inputIds.push(`${this.id}_${x.key}_${uniqId}`);
        radio += `
            <input
              type="radio"
              name="${this.name}"
              id="${this.id}_${x.key}_${uniqId}"
              value="${x.key}"
              data-other="${x.isOther}"
              class="qform-field__block_box__field-box__input ${x.isOther ? "other-item" : ""}">
            <label for="${this.id}_${x.key}_${uniqId}" class="${this.classes} ${x.isOther ? "other-item__label" : ""}">
              <div class="qform-field__block_box__field-box__label">        
                <span class="qform-field__block_box__field-box__label_img_text">${x.value}</span>
                ${/* Проверка на существование видео или картинки */
        this.imageData[index].mainVideo || this.imageData[index].image ? `<div class="qform-field__block_box__field-box__label_img ${this.formWidth < 550 && this.formWidth !== 0 ? "small-label" : ""}" style="border-radius: ${this.fieldRounding}">
                    ${this.imageData[index].mainVideo === undefined ? this.imageData[index].image ? `<img class="gallery-${this.id}" src="${x.image}"  alt="${this.imageData[index].description}" />
                    <a href="${x.image}" class="qform-field__block_box__field-box__label_img__button" data-caption="${this.imageData[index].index + 1}/${option.length} ${this.imageData[index].description}" aria-label="Увеличить">
                    </a>` : "" : videoItem?.HTML}
                </div>` : ""}
              
              </div>
              <div class="qform-field__block_box__field-box__check">
                <div class="checked"></div>
              </div>
            </label>
            ${x.isOther ? `<div class="qform-other-item__box" id="${this.otherInputBoxId}">
              <input id="${this.otherInputId}" class="qform-other-item__input" placeholder="${this.messages.typeVariant.replace(/"/g, "&quot;")}" />               
            </div>` : ""}`;
      });
    }
    radio += `
                </div>
              </div>
            </div>
          </div>
        </div>
        ${this.toHtmlBottomBox(false)}
      </div>
      `;
    return radio;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // this.$input = this.$root.$el.querySelector(`#${this.id}`);`
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$label = this.$root.$el.querySelector(`#${this.labelId}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    this.listeners = [];
    this.inputIds.forEach(x => {
      const input = document.getElementById(x);
      input.disabled = disable;
      if (input) {
        //если вариант отмечен по умолчанию
        input.checked = x.includes(this.defaultValueId);
        !disable && this.listeners.push({
          eventName: "change",
          method: "onChange",
          el: input
        });
      }
    });
    if (this.$otherInput) {
      this.listeners.push({
        eventName: "input",
        method: "onOtherInputInput",
        el: this.$otherInput
      });
      this.listeners.push({
        eventName: "focus",
        method: "onOtherInputFocus",
        el: this.$otherInput
      });
      this.listeners.push({
        eventName: "blur",
        method: "onOtherInputBlur",
        el: this.$otherInput
      });
    }
    const savedData = JSON.parse(localStorage.getItem(this.options.formId));
    if (savedData) {
      const savedValues = savedData[this.name];
      if (savedValues) {
        for (let inputId of this.inputIds) {
          const input = document.getElementById(inputId);
          if (input) {
            input.checked = savedValues.includes(input.value);
          }
        }
      }
    }
    super.init();
    baguetteBox.run(".qform-field__block_box__field-box", {
      ...baguetteConfig
    });
    if (this.allStyle) {
      this.setClassField(this.allStyle);
    }
    const widgetIndexes = [];
    this.imageData.forEach((widgetData, i) => {
      if (!!widgetData.mainVideo) {
        if (videoJs.getPlayer(`video_${widgetData.key}_${this.name}_thumb`)) {
          videoJs.getPlayer(`video_${widgetData.key}_${this.name}_thumb`).dispose();
        }
        widgetIndexes.push(i);
        const player = videoJs(`video_${widgetData.key}_${this.name}_thumb`, {
          controls: false,
          autoplay: false,
          muted: true,
          // Отключаем звук для разрешения автопроигрывания
          preload: "auto",
          poster: widgetData.preview === null ? `${widgetData.preview}` : false,
          fluid: true,
          fill: true,
          html5: {
            hls: {
              overrideNative: true
            }
          }
        });
        const videoElement = document.getElementById(`video_${widgetData.key}_${this.name}_thumb`);
        videoElement.closest(".qform-field__block_box__field-box__label_img").addEventListener("mouseenter", () => {
          player.play().catch(error => {
            console.warn(`Проигрывание не удалось: ${error}`);
          });
        });
        videoElement.closest(".qform-field__block_box__field-box__label_img").addEventListener("mouseleave", () => {
          player.pause();
        });
        const fullscreenButton = document.createElement("div");
        fullscreenButton.classList.add("qform-field__block_box__field-box__label_img__button", "widget");
        videoElement.parentNode.appendChild(fullscreenButton);
        fullscreenButton.addEventListener("click", () => {
          this.#currentIndex = widgetIndexes.indexOf(i);
          this.openModal();
        });
        this.videoWidgets.push(player);
      }
    });
  }
  openModal() {
    const modalDialogWrapper = document.createElement("div");
    modalDialogWrapper.classList.add("qform-teleports-modal");
    modalDialogWrapper.innerHTML = this.getModalContent();
    document.body.appendChild(modalDialogWrapper);
    this.updateModalContent(modalDialogWrapper);
  }
  getModalContent() {
    /**
     * @type FormFieldOption */
    const widgetData = this.widgetData[this.#currentIndex];
    return `
      <div class="qform-modal-content">
          
          <div class="qform-modal-video">
            <video id="video_${widgetData.key + this.name}_modal" class="video-js vjs-default-skin" controls autoplay muted preload="auto" style="height: 90%;">
                <source src="${widgetData.videowidget.mainVideo}" type="application/x-mpegURL">
            </video>  
            <span class="qform-field__block_box__field-box__label_img_text" title="${widgetData.value}"  style="${this.allStyle.formStyleText.font?.cssName ?? ""}; font-size: ${(this.allStyle.formStyleText.fontSize || 0) + "px"};">${this.#currentIndex + 1}/${this.widgetData.length} ${widgetData.value}</span>
             ${widgetData.videowidget.showLogo ? `<div class="label-qform">
                      <a href="${widgetData.videowidget.logoLink}" target="_blank" rel="noopener">видеовиджет QForm.io</a>
                    </div>` : ""}
             <div class="qf-widget-actions">
               <div role="button" class="qf-widget-btn qf-mute-btn"></div>
                <div style="display: inline-flex; align-items:center; gap: 11px;">
                <div role="button" class="qf-widget-btn qf-replay-widget"></div>                
                <div class="qf-widget-time">0:00</div>
              </div>
             </div>
          
              <div role="button" class="play-btn"></div>
              </div>
          <button type="button" class="qbtn previous-button" aria-label="Previous" class="baguetteBox-button" style="display: flex;">
            <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 1.5L5 8.5L10 15.5" stroke="#828282" stroke-width="2"></path>
            </svg>
          </button>
          <button type="button" class="qbtn next-button" aria-label="Previous" class="baguetteBox-button" style="display: flex;">
            <svg width="20" height="20" viewBox="0 0 8 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.5L6 8.5L1 15.5" stroke="#828282" stroke-width="2"></path>
            </svg>
          </button>
          <button class="qbtn close-modal">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L13 13M1 13L13 1" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
          </button>
      </div>
    `;
  }

  /**
   * Обновляет содержимое модального окна при смене видео.
   * @param {HTMLElement} modalDialogWrapper - Контейнер модального окна.
   */
  updateModalContent(modalDialogWrapper) {
    modalDialogWrapper.innerHTML = this.getModalContent();
    const modalPlayer = this.createModalPlayer(this.#currentIndex);

    /**
     * @type HTMLButtonElement
     * */
    const muteBtn = modalDialogWrapper.querySelector(".qf-mute-btn");
    /**
     * @type HTMLButtonElement
     * */
    const playBtn = modalDialogWrapper.querySelector(".play-btn");
    /**
     * @type HTMLButtonElement
     * */
    const replayBtn = modalDialogWrapper.querySelector(".qf-replay-widget");
    /**
     * @type HTMLDivElement
     * */
    const time = modalDialogWrapper.querySelector(".qf-widget-time");
    /**
     * @type HTMLDivElement
     * */
    const video = modalDialogWrapper.querySelector("video.vjs-tech");
    video.addEventListener("click", async () => {
      modalPlayer.paused() ? await modalPlayer.play() : modalPlayer.pause();
    });
    playBtn.addEventListener("click", async () => {
      await modalPlayer.play();
    });
    muteBtn.addEventListener("click", ev => {
      ev.target.classList.toggle("muted");
      modalPlayer.muted(ev.target.classList.contains("muted"));
    });
    replayBtn.addEventListener("click", () => {
      modalPlayer.currentTime(0);
    });
    const closeModalBtn = modalDialogWrapper.querySelector(".close-modal");
    closeModalBtn.addEventListener("click", () => {
      modalPlayer.dispose();
      document.body.removeChild(modalDialogWrapper);
      this.#currentIndex = null;
    });
    const nextVideoBtn = modalDialogWrapper.querySelector(".next-button");
    nextVideoBtn.addEventListener("click", () => {
      this.#currentIndex = this.#currentIndex === this.widgetData.length - 1 ? 0 : this.#currentIndex + 1;
      modalPlayer.dispose();
      this.updateModalContent(modalDialogWrapper);
    });
    const prevVideoBtn = modalDialogWrapper.querySelector(".previous-button");
    prevVideoBtn.addEventListener("click", () => {
      this.#currentIndex = this.#currentIndex === 0 ? this.widgetData.length - 1 : this.#currentIndex - 1;
      modalPlayer.dispose();
      this.updateModalContent(modalDialogWrapper);
    });
    modalPlayer.on("timeupdate", () => {
      time.innerText = this.getFormatRemainingTimeDisplay(modalPlayer.remainingTimeDisplay());
    });

    /*modalPlayer.on("ended", () => {
      nextVideoBtn.click();
    });*/
  }

  /**
   * Создает видеоплеер для модального окна.
   * @param {number} index - Индекс текущего видео.
   * @returns {Object} Экземпляр плеера video.js.
   */
  createModalPlayer(index) {
    /**
     * @type FormFieldOption
     * */
    const widgetData = this.widgetData[index];
    /**
     * @type {Object<any>}
     * */
    const options = {
      controls: false,
      autoplay: true,
      muted: false,
      preload: "auto",
      poster: widgetData.videowidget.preview ? `${widgetData.videowidget.userPreviewImg}` : false,
      fluid: true,
      html5: {
        hls: {
          overrideNative: true
        }
      },
      children: ["mediaLoader"]
    };
    const player = videoJs(`video_${widgetData.key + this.name}_modal`, options);
    if (!widgetData.videowidget.showLogo && widgetData.videowidget.showTimeline) {
      const componentProgressBar = videoJs.getComponent("ProgressControl");
      const ProgressBar = new componentProgressBar(player);
      player.addChild(ProgressBar);
    }
    return player;
  }

  /**
   * @param {Number} seconds
   * @returns {"hh:mm:ss" || "mm:ss"}
   * */
  getFormatRemainingTimeDisplay(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainingSeconds = seconds % 60;
    if (hours > 0) {
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    } else {
      return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    }
  }
  removeClassPosition() {
    this.$box.classList.remove();
  }
  setClassField(data) {
    this.styles = data;
    //  .top | .right | .bottom | .left | <empty>
    if (data && typeof data.formStyleRadio !== "undefined" && typeof data.formStyleRadio.position !== "undefined") {
      if (typeof this.classPosition[data.formStyleRadio.position] !== "undefined") {
        this.$box.classList.add(this.classPosition[data.formStyleRadio.position]);
      } else {
        this.$box.classList.add(this.classPosition[3]);
      }
    }
    if (data.formStyleRadio.direction) {
      //добавляем класс расположения "в ряд"
      this.$box.classList.add("qform-list-in-row");
    }
    if (!data.formStyleRadio.useDesign) {
      let arrClass = this.$root.$el.classList.value.split(" ");
      arrClass.forEach(nameClass => {
        if (nameClass.trim()) {
          this.$root.$el.classList.remove(nameClass);
        }
      });
      const labelPrefix = "qform-field__block_box__field-box__label";
      const labels = document.querySelectorAll(`.${labelPrefix}`);
      const imgTexts = document.querySelectorAll(`.${labelPrefix}_img_text`);
      const images = document.querySelectorAll(`.${labelPrefix}_img`);

      //удаляем классы с контейнеров контента вариантов выбора
      for (let i = 0; i < labels.length; i++) {
        labels[i].classList.remove(labelPrefix);
      }

      //удаляем классы с текста вариантов выбора с изображениями
      for (let i = 0; i < imgTexts.length; i++) {
        imgTexts[i].classList.remove(`${labelPrefix}_img_text`);
      }

      //удаляем классы с картинок вариантов выбора с изображениями
      for (let i = 0; i < images.length; i++) {
        images[i].classList.remove(`${labelPrefix}_img`);
      }
    }
    // .required | .not-required
    if (data && typeof data.formStyleFieldRequired !== "undefined") {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add("required");
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add("not-required");
      }
      if (!data.formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required");
        this.$box.classList.remove("not-required");
      }
    }
  }
  getValue() {
    let values = [];
    this.inputIds.forEach(x => {
      let input = document.getElementById(x);
      if (input && input.checked) {
        if (Number(input.dataset.other) === 1) {
          // this$otherInput = this.$root.$el.querySelector(`#${this.otherInputId}`);
          values.push(JSON.stringify({
            [input.value]: this.$otherInput.value
          }));
        } else {
          values.push(input.value);
        }
      }
    });
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: values
    };
  }
  onChange(event) {
    event.preventDefault();
    if (this.saveInStorage) {
      let storage = JSON.parse(localStorage.getItem(this.options.formId));
      if (storage) {
        storage[this.name] = this.getValue().values;
      }
      localStorage.setItem(this.options.formId, JSON.stringify(storage));
    }
    this.validation(false);
    this.$emit("Change:field", {});
  }
  onOtherInputInput() {
    this.validation();
    this.$emit("Change:field", {});
  }
  onOtherInputFocus() {
    this.$otherInputBox?.classList.add("qform-field-focus");
  }
  onOtherInputBlur() {
    this.validation();
    this.$otherInputBox?.classList.remove("qform-field-focus");
  }
  toggleOtherInputBoxErrorClass(isError) {
    this.$otherInputBox.classList.toggle("qform-field-error", isError);
  }
  validation() {
    let setMessageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    let values = [];
    let isEmptyOther = false;
    let isOverLength = false;
    let atLeastOneRadioChecked = false;
    this.inputIds.forEach(x => {
      let input = document.getElementById(x);
      if (Number(input.dataset.other) === 1) {
        if (input.checked) {
          if (!this.$otherInput.value) {
            isEmptyOther = true;
            valid = false;
          } else if (this.$otherInput.value.length > 255) {
            isOverLength = true;
            valid = false;
          }
          this.toggleOtherInputBoxErrorClass(!this.$otherInput.value && setMessageValid);
        }
      }
      if (this.require) {
        if (input && input.checked) {
          values.push(input.value);
        }
      }
      if (input.checked) {
        atLeastOneRadioChecked = true;
      }
    });
    if (values.length === 0 && this.require) {
      valid = false;
    }
    if (valid) {
      this.setMessageValid();
    } else if (isEmptyOther) {
      setMessageValid ? this.setMessageValid(this.messages.fillRequired) : null;
    } else if (isOverLength) {
      setMessageValid ? this.setMessageValid(this.messages.tooLongOtherField || "Too long other field text value") : null;
    } else {
      setMessageValid ? this.setMessageValid(this.messages.inputRequired) : null;
    }
    this.setSuccessValid(valid && atLeastOneRadioChecked);
    return valid;
  }
  setOption(options) {
    if (Array.isArray(options)) {
      if (this.shuffle_answers) {
        options = options.sort(() => Math.random() - 0.5);
      }
      options.sort((a, b) => {
        if (a.isOther && !b.isOther) {
          return 1; // a идет после b
        } else if (!a.isOther && b.isOther) {
          return -1; // a идет перед b
        } else {
          return 0; // остальные элементы остаются на своих местах
        }
      });
      this.imageData = options.filter(el => el.formFieldId === this.fieldId).map((item, index) => {
        let ov = "";
        if (item.videowidget.orientationVideo === 1) {
          ov = "vertical-widget-gallery";
        }
        if (item.videowidget.orientationVideo === 2) {
          ov = "square-widget-gallery";
        }
        if (item.videowidget.orientationVideo === 3) {
          ov = "horizontal-widget-gallery";
        }
        if (item.videowidget.mainVideo) {
          this.widgetData.push(item);
        }
        return {
          index: index,
          formField: item.formField,
          formFieldId: item.formFieldId,
          image: item.image,
          description: item.value,
          key: item.key,
          value: item.value,
          id: item.videowidget.id,
          mainVideo: item.videowidget.mainVideo,
          orientationVideo: ov,
          preview: item.videowidget.preview,
          showLogo: item.videowidget.showLogo,
          showTimeline: item.videowidget.showTimeline
        };
      });

      // Убрал перетосовку ответов, теперь это делается на бэке
      // if (this.shuffle_answers) {
      //   options = options.sort(() => Math.random() - 0.5);
      // }
      let arrOption = [];
      options.forEach(option => {
        if (option.formFieldId === this.fieldId) {
          arrOption.push(option);
          //если вариант выбран по умолчанию
          if (option.defaultValue && !this.defaultValueId) {
            this.defaultValueId = `${this.id}_${option.key}`;
          }
        }
      });

      //добавляем разметку вариантов к форме
      let el;
      for (let i = 0; i < this.$root.$el.children.length; i++) {
        if (this.$root.$el.children[i].id === this.boxId) {
          el = this.$root.$el.children[i];
        }
      }
      el.insertAdjacentHTML("beforebegin", this.toHTML(arrOption, true));
      el.remove();
      this.$otherInput = this.$root.$el.querySelector(`#${this.otherInputId}`);
      this.$otherInputBox = this.$root.$el.querySelector(`#${this.otherInputBoxId}`);
    }
    this.init({
      disable: !this.options.data.active
    });
  }
}